import { render, staticRenderFns } from "./examen-bio-resultats.html?vue&type=template&id=f6fda3b2&scoped=true&external"
import script from "./examen-bio-resultats.js?vue&type=script&lang=js&external"
export * from "./examen-bio-resultats.js?vue&type=script&lang=js&external"
import style0 from "./examen-bio-resultats.scss?vue&type=style&index=0&id=f6fda3b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fda3b2",
  null
  
)

export default component.exports